module.exports = __webpack_public_path__ + "static/media/ycombinator.25fadc1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/ycombinator.png
// module id = 129
// module chunks = 0